import { useCloseWindow } from "~/hooks/use-close-window";

export function ErrorComponent() {
  const closeWindow = useCloseWindow("https://swipelux.com");

  return (
    <div className="flex h-dvh w-full flex-col items-center justify-center gap-6">
      <h1 className="text-center text-3xl font-bold">
        Failed to proceed with the checkout
      </h1>

      <button
        type="button"
        className="rounded-xl bg-black px-4 py-2 text-base font-bold text-white"
        onClick={closeWindow}
      >
        Return back
      </button>
    </div>
  );
}
